import { CgDocType } from '../ocr/ocrResponseTypes';

/**
 * Queue d'upload par défaut de FormCGIA, dans l'ordre attendu par le client.
 * Cet ordre suit la slide "Pièces justificatives obligatoires" du Manop.
 *
 * Recalcul dynamique (v2 — non implémenté pour l'instant) :
 *  - `controle_technique` serait skippé si MEC < 4 ans (détecté après carte_grise).
 *  - En mode `guest` (hébergement par un tiers), `attestation_hebergement` serait
 *    ajouté après `justif_domicile`.
 *  - En mode pro, `kbis` remplacerait `permis_conduire`.
 */

export const DEFAULT_DOCUMENT_QUEUE: readonly CgDocType[] = [
  'carte_grise',
  'cerfa_cession',
  'cerfa_demande_immat',
  'mandat',
  'assurance',
  'controle_technique',
  'piece_identite',
  'permis_conduire',
  'justif_domicile',
];

/**
 * Limite silencieuse du nombre de fichiers par step d'upload.
 * Le client a explicitement demandé "2 fichiers max, sans le dire à l'utilisateur"
 * pour couvrir les cas recto/verso (CG, CNI, permis, etc.) tout en gardant
 * l'UX "un document par étape".
 */
export const MAX_FILES_PER_STEP = 2;

/**
 * Seuil minimum de confiance pour valider qu'un document correspond bien au
 * type attendu (`docTypeMatchConfidence`).
 */
export const DOC_TYPE_MATCH_THRESHOLD = 0.9;
